import React, { useState, useEffect, useRef } from "react";

import Billing from "../Settingsandcontrolmanagment/Food/Billing";
// import Employee from "../Settingsandcontrolmanagment/Food/Employee";
// import Tablereservation from "./Tablereservation";
import Tablereservations from "../Settingsandcontrolmanagment/Food/Tablereservations";
// import Tickets from "../Settingsandcontrolmanagment/Food/Tickets";
import Timings from "../Settingsandcontrolmanagment/Food/Timings";
import Foodandbeveragesadvertise from './Foodandbeveragesadvertise';
import { Link } from "react-router-dom";
import { useLoader } from "../../../context/LoaderProvider.jsx";

const Foodsettings = () => {
    const plan = localStorage.getItem("planType") || "standard";
    const [activeTab, setActiveTab] = useState('Timings');
    const [isHovered, setIsHovered] = useState(false);
    const scrollContainerRef = useRef(null);
    const isMobile = window.innerWidth <= 768;
    const { showLoader, hideLoader } = useLoader();

    // ✅ Example loader usage (simulate data loading)
    useEffect(() => {
        const loadData = async () => {
            try {
                showLoader(); // show loader when page/tab is changing
                // Simulate API call
                await new Promise((res) => setTimeout(res, 800));
            } finally {
                hideLoader(); // always hide loader after completion
            }
        };
        loadData();
    }, [activeTab]);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval;

        const startScrolling = () => {
            interval = setInterval(() => {
                if (!isHovered) {
                    scrollContainer.scrollTop += 1; // Scroll down smoothly

                    // Infinite loop logic
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
                        scrollContainer.scrollTop = 0; // Reset to top for seamless loop
                    }
                }
            }, 20); // Adjust speed by changing interval
        };

        startScrolling();
        const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        return () => clearInterval(interval);
    }, [isHovered]);

    const fileInputRef = useRef(null);
    // {=======================overview===============================}
    const allTabs = {

        Timings: <Timings />,
        // Employee: <Employee />,
        "Billing SetUp": <Billing />,
        Table: <Tablereservations />,
        // "View Tickets": <Tickets />,
    };

    // Filter tabs by plan
    const getTabsForPlan = (plan) => {
        switch (plan.toLowerCase()) {
            case "basic":
                return ["Timings", "Billing SetUp" ];
            case "standard":
                return [ "Timings", "Billing SetUp"];
            case "premium":
                return [  "Timings","Billing SetUp", "Table"];
            default:
                return ["Timings"];
        }
    };

    const visibleTabKeys = getTabsForPlan(plan);
    return (<>


        <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
         
        }

         .tabs-wrapperyy {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
          margin-top:67px;
}
// .left-column {
//             width: 100%;
//             padding-right: 140px;
//             max-height: 700px;
           
//           }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapper {
    margin-left: 0;
    
  }
    .profile-mobilescroll{
    margin-top:48px !important;
    
    }
}
    @media screen and (min-width: 768px) {
.profile-mobilescroll{
    margin-top:140px !important;
    
    }
        }

        .tab-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:50px;
         
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: 132px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          background-color: #b15cd6;
        }

        .tab-content {
          margin-top: 0px;
          width: 100%;
        }

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }

        

        
        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }

          

          .left-column {
            width: 100%;
            padding-right: 95px;
            max-height: 700px;
           
          }
             

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapper{
            margin-left:none

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
      `}</style>

        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-7">
                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                                top: window.innerWidth <= 425 ? "40px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px" ,                            
                            left: "2vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                            padding: "10px 0",
                            fontSize: isMobile ? "16px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        {/* <Link
                            to="/Newmainlandingpage"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link> */}
                        {/* <span className="separator"> &gt; </span> */}

                        <Link
                            to="/fooddashboard"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Food & Beverages
                        </Link>

                        <span className="separator"> &gt; </span>

                        <Link
                            // to="/company"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Settings & Control
                        </Link>

                    </p>




                    {/* Left Section */}
                    <div className="profile-mobilescroll" >
                        <div >

                            <div className="tab-buttons" style={{}}>
                                {visibleTabKeys.map((label) => (
                                    <button
                                        key={label}
                                        className={`tab-button ${activeTab === label ? "active" : ""}`}
                                        onClick={() => setActiveTab(label)}
                                    >
                                        {label}
                                    </button>
                                ))}
                            </div>
                            <div className="tab-content" style={{
                                 height: '60vh', scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}> {allTabs[activeTab]}</div>
                        </div>
                    </div>


                </div>


                <div className="col-lg-3">
                    <Foodandbeveragesadvertise />
                </div>

            </div>
        </div>
    </>
    );
};



export default Foodsettings;
